import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SocketService } from '../../../../services/socket';

type GavelMode = 'nominating' | 'bidding' | 'paused';

@Component({
  selector: 'app-gavel-options',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './gavel-options.html',
  styleUrl: './gavel-options.css'
})
export class GavelOptions {
  @Input() leagueId!: number;
  @Input() mode: GavelMode = 'nominating';
  @Input() bottomStrip = false;
  @Input() showNomFor = false;
  @Input() bidOnBehalfUserId: number | null = null;
  @Input() bidOnBehalfMaxBid: number | null = null;

  @Output() nomForClick = new EventEmitter<void>();
  @Output() bidOnBehalfChange = new EventEmitter<number | null>();

  constructor(public socketService: SocketService) {}

  pause() { this.socketService.pauseDraft(this.leagueId); }
  resume() { this.socketService.resumeDraft(this.leagueId); }
  startCountdown() { this.socketService.startCountdown(this.leagueId); }
  stopCountdown() { this.socketService.stopCountdown(this.leagueId); }
  endAuction() { this.socketService.endAuction(this.leagueId); }

  onBehalfChange(value: string | number | null) {
    this.bidOnBehalfChange.emit(value ? +value : null);
  }
}
